import { render, staticRenderFns } from "./digitRecords.vue?vue&type=template&id=47a64c6c&scoped=true"
import script from "./digitRecords.vue?vue&type=script&lang=js"
export * from "./digitRecords.vue?vue&type=script&lang=js"
import style0 from "./digitRecords.vue?vue&type=style&index=0&id=47a64c6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a64c6c",
  null
  
)

export default component.exports